import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import { WHITE, PINK, PURPLE } from '../../../constants/colors';

export default {
  categoriesmenu: css`
  display:block;
  ${media.sm`
    display:none;
  `};
  `,
  categories: css`
  display:none;
  ${media.sm`
    display:block;
  `};
  `,
  categoriesWrapper: css`
  padding-left:35px;
  padding-right:35px;
  ${media.sm`
    padding-left:0;
    padding-right:0;
  `};
  `,
  fluidwrapper: css`
  max-width:100%;
  margin-top:50px;
  ${media.sm`
    max-width:768px;
    padding-left:10px;
    padding-right:10px;
    margin-left:auto;
    margin-right:auto;
  `};
  ${media.md`
    max-width:960px;
    padding-left:0px;
    padding-right:0px;
    margin-left:auto;
    margin-right:auto;
  `};
  `,
  subtitle: css`
  text-align:center;
  font-size: ${rem(16)};
  color: ${PINK};
  margin-bottom:40px;
  ${media.sm`
    text-align:left;
    font-size: ${rem(18)};
  `};
  ${media.md`
    font-size: ${rem(24)};
  `};
  `,
  title: css`
  text-align:center;
  font-size: ${rem(24)};
  color: ${PURPLE};
  margin-bottom:10px;
  ${media.sm`
    color: ${WHITE};
    text-align:left;
    font-size: ${rem(28)};
  `};
  ${media.md`
    font-size: ${rem(42)};
  `};
  `,
  wrapper: css`
    margin-top: 30px;
     margin-bottom: 32px;
  ${media.md`
    margin-top: 60px;
  `};
  `,
};
